import { render, staticRenderFns } from "./VCopyUnlock.vue?vue&type=template&id=1919a53c&"
import script from "./VCopyUnlock.vue?vue&type=script&lang=ts&"
export * from "./VCopyUnlock.vue?vue&type=script&lang=ts&"
import style0 from "./VCopyUnlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports